import React from "react";
import AdminTable from "../admin_table";

export default function QueryManagement() {
  return (
    <div className="text-[#fff] font-bold text-2xl h-screen w-screen bg-[#161E2D] ">
      <AdminTable />
    </div>
  );
}
